import React from 'react';
import { Row, Col } from 'reactstrap';

const NotesTab = () => {
  return (
    <Row>
      <Col md={12}>
        <div className="text-center p-4">
          <h5>Notes</h5>
          <p className="text-muted">Account notes content will be implemented here.</p>
        </div>
      </Col>
    </Row>
  );
};

export default NotesTab; 